import { useState } from 'react'
import { connect } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { logout } from "../../redux/actions/auth/auth"

import { Dialog, DialogPanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

import logo from "assets/images/logo.webp"

function Navbar({
  isAuthenticated,
  user,
  logout,
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navigate = useNavigate()
  const location = useLocation();
  const query = new URLSearchParams(location.search)

  const [searchData, setSearchData] = useState({
          evento: query.get("evento"),
          ciudad: query.get("ciudad"),
          fecha: query.get("fecha"),
  });
  
  const onChange = e => setSearchData({
      ...searchData,
      [e.target.name]: e.target.value
  });

  const onSubmit = (e) => {
      e.preventDefault();
      const queryParams = new URLSearchParams(searchData).toString();
      navigate(`/eventos?${queryParams}`);
  };

  const handleLogout=()=>{
    logout()
  }

  return (
      <header className="sticky inset-x-0 top-0 z-50">
        <nav aria-label="Global" className={`flex items-center justify-between px-8 py-4 transition-all duration-300 ${
                                    location.pathname === "/" 
                                      ? "bg-black text-white shadow-lg" 
                                      : location.pathname === "/trips" 
                                      ? "bg-white text-black"
                                      : location.pathname === "/new_trip"
                                      ? "bg-white text-black"
                                      : "bg-white text-black shadow-lg"
                                  }`}>
          
          {location.pathname === "/eventos" ? (
              <div className='flex items-center justify-center gap-x-10'>
                <div className='mt-2'>
                    <Link to='/'>
                      <img src={logo} width={150} height={100}/>
                    </Link>
                </div>

                <form onSubmit={(e) => onSubmit(e)} className="hidden md:inline-flex rounded-3xl bg-white shadow-sm border">

                      <input
                          id='evento'
                          name='evento'
                          placeholder="Artista, evento o recinto"
                          value={searchData.evento}
                          onChange={(e)=>onChange(e)}
                          type='text'
                          className="m-1 border-none focus:ring-0 border-r rounded-3xl hover:bg-gray-200 focus:bg-gray-200"
                      />

                      <select
                          id='ciudad'
                          name='ciudad'
                          placeholder="ciudad"
                          value={searchData.ciudad}
                          onChange={(e)=>onChange(e)}
                          className="m-1 border-none focus:ring-0 rounded-3xl hover:bg-gray-200"
                      >
                              <option value="">Seleccionar ciudad</option>
                              <option value="madrid">Madrid</option>
                              <option value="barcelona">Barcelona</option>
                      </select>

                      <input
                          id='fecha'
                          name='fecha'
                          placeholder="fecha"
                          value={searchData.fecha}
                          onChange={(e)=>onChange(e)}
                          type='date'
                          className="m-1 border-none focus:ring-0 rounded-3xl hover:bg-gray-200"
                      />

                      <button
                      type="submit"
                      className="bg-blue-green px-10 py-1 text-white font-bold text-lg rounded-r-3xl py-4 hover:bg-blue-green-dark"
                      >
                      Buscar
                      </button>
                </form>  
              </div>
            ):
            (
              <div className='mt-2'>
                <Link to='/'>
                  <img src={logo} width={150} height={100}/>
                </Link>
              </div>
            )
          }

          <div className="flex md:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            >
              <Bars3Icon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>

          <div className="hidden md:flex md:justify-end md:items-center md:space-x-4">
            <Link to="/new_trip" className='font-semibold flex gap-x-2 items-center mr-8 hover:scale-105 duration-500'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              Publicar Trip
            </Link>
            {isAuthenticated ? (
            <Menu as="div" className="relative">
              <MenuButton className="relative flex rounded-full bg-gray-800 text-sm ring-black ring-1 hover:ring-2">
                {user&&user.profile_picture ? (
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_MEDIA}${user.profile_picture}`}
                    className="h-10 w-10 rounded-full ring-2 ring-white"
                  />
                ):
                (
                  <img
                    alt=""
                    className="h-10 w-10 rounded-full bg-gray-300"
                  />
                )
                }
                
              </MenuButton>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <MenuItem>
                  <Link to={`/trips`}  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100">
                    Mis Trips
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to={`/profile/me`}  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100">
                    Perfil
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link 
                    to='/'
                    onClick={()=>handleLogout()} 
                    className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100">
                    Cerrar sesión
                  </Link>
                </MenuItem>
              </MenuItems>
            </Menu>
            ):(
              <>
              <Link to='/login' className="text-sm font-semibold leading-6">
                  Iniciar sesión <span aria-hidden="true"></span>
              </Link>
              </>
            )}
          </div>

        </nav>

        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="md:hidden">
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to='/' 
                className="-m-1.5 p-1.5"
                onClick={() => setMobileMenuOpen(false)}
              >
                  <img src={logo} width={150} height={100}/>
              </Link>
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
              >
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10"> 
                <div className="py-6">
                  <Link to="/new_trip" className='-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7'>
                        Publicar Trip
                  </Link>
                  {isAuthenticated ? (
                    <>
                    <Link to={`/trips`}  className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">
                      Mis Trips
                    </Link>
                     <Link to={`/profile/me`} className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      Perfil
                    </Link>
                    <Link 
                      to="/" 
                      className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      onClick={()=>handleLogout()} 
                    >
                      Cerrar sesión
                    </Link>
                    </>
                   
                  ):(
                    <>
                      <Link to='/login'
                        onClick={() => setMobileMenuOpen(false)}
                        className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7"
                      >
                        Iniciar Sesion
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>

      </header>   
  )
}

const mapStateToProps=state=>({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user
})

export default connect (mapStateToProps, {
  logout,
})(Navbar)



